import { render, staticRenderFns } from "./InputGroup.vue?vue&type=template&id=128c2fca&scoped=true"
import script from "./InputGroup.vue?vue&type=script&lang=js"
export * from "./InputGroup.vue?vue&type=script&lang=js"
import style0 from "./InputGroup.vue?vue&type=style&index=0&id=128c2fca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128c2fca",
  null
  
)

export default component.exports